// recursively find string children from a react node
const stringFromNode = node => {
  if (!node) {
    return '';
  }
  if (typeof node === 'string') {
    return node;
  }
  if (Array.isArray(node)) {
    return node.map(stringFromNode).join('\n');
  }
  return stringFromNode(node.props.children);
};

export default stringFromNode;
